import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from '../modals/DefaultModal';

function BancoModal({ show, onClose, banco, onSaveSuccess }) {
  const [form, setForm] = useState({ id: '', nome: '', website: '' });
  const [isSaving, setIsSaving] = useState(false);
  const [modalData, setModalData] = useState({
    show: false,
    type: '',
    message: '',
  });
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (banco) {
      setForm({
        id: banco.id || '',
        nome: banco.nome || '',
        website: banco.website || '',
      });
    } else {
      setForm({ id: '', nome: '', website: '' });
    }
  }, [banco, show]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'website') {
      setForm(prev => ({ ...prev, [name]: value }));
    } else {
      setForm(prev => ({ ...prev, [name]: value.toUpperCase() }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSaving(true);
    try {
      const method = banco ? 'put' : 'post';
      const url = banco
        ? `${API_BASE_URL.BANCO}/update/${form.id}`
        : `${API_BASE_URL.BANCO}/create`;
      const payload = { id: form.id, nome: form.nome, website: form.website };
      const axios = (await import('axios')).default;
      const response = await axios[method](url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200 || response.status === 201) {
        setModalData({
          show: true,
          type: 'success',
          message: 'Banco salvo com sucesso!',
        });
        if (onSaveSuccess) onSaveSuccess(response.data);
      } else {
        setModalData({
          show: true,
          type: 'error',
          message: 'Erro ao salvar banco.',
        });
      }
    } catch {
      setModalData({
        show: true,
        type: 'error',
        message: 'Erro ao salvar banco.',
      });
    } finally {
      setIsSaving(false);
    }
  };

  const closeDefaultModal = () => {
    setModalData(prev => ({ ...prev, show: false }));
    if (modalData.type === 'success') {
      onClose();
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: 'block' }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {banco ? 'Editar Banco' : 'Novo Banco'}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Código</label>
                <input
                  type="text"
                  className="form-control"
                  name="id"
                  value={form.id}
                  onChange={handleChange}
                  required
                  maxLength={3}
                  disabled={!!banco}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Nome</label>
                <input
                  type="text"
                  className="form-control"
                  name="nome"
                  value={form.nome}
                  onChange={handleChange}
                  required
                  maxLength={100}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Website</label>
                <input
                  type="url"
                  className="form-control"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                  maxLength={200}
                  placeholder="https://www.exemplo.com"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={isSaving}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSaving}
              >
                {isSaving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
      <DefaultModal
        show={modalData.show}
        type={modalData.type}
        onClose={closeDefaultModal}
        message={modalData.message}
      />
    </div>
  );
}

export default BancoModal;
